// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/routes/progress-report/routes/ProgressReport/components/ProgressReport/components/PastSessions/components/ModuleBlock/ModuleBlock.scss
// module id = 790
// module chunks = 0